import { render, staticRenderFns } from "./Detailed2.vue?vue&type=template&id=665a1425&"
import script from "./Detailed2.vue?vue&type=script&lang=js&"
export * from "./Detailed2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports